<app-base-modal [isOpen]="isOpen" (close)="onClose()">
  <h1 header>Account Info</h1>

  <form [formGroup]="form" class="edit-client-info-form" (ngSubmit)="onSubmit()">
    <label class="form-input-wrapper">
      <input formControlName="firstName" placeholder="Name" class="form-input_md" />
    </label>

    <label class="form-input-wrapper">
      <input formControlName="lastName" placeholder="Surname" class="form-input_md" />
    </label>

    <label class="form-input-wrapper">
      <input formControlName="billingEmail" type="email" placeholder="Billing email" class="form-input_md" />
    </label>

    <label class="form-input-wrapper">
      <input formControlName="phoneNumber" type="tel" placeholder="Phone number" class="form-input_md" />
    </label>

    <label class="form-input-wrapper edit-client-info-form__full">
      <input formControlName="companyName" placeholder="Company name" class="form-input_md" />
    </label>

    <label class="form-input-wrapper edit-client-info-form__full">
      <input formControlName="address" placeholder="Street address" class="form-input_md" />
    </label>

    <label class="form-input-wrapper">
      <input formControlName="mailStop" placeholder="Ste, Bldg, Mail stop (Optional)" class="form-input_md" />
    </label>

    <label class="form-input-wrapper">
      <input formControlName="city" placeholder="City" class="form-input_md" />
    </label>

    <label class="form-input-wrapper">
      <input formControlName="zipCode" placeholder="ZIP Code" class="form-input_md" />
    </label>

    <label class="form-input-wrapper">
      <app-select
        [items]="states"
        [activeItem]="form.value.state"
        placeholder="State"
        [customClass]="['select_max']"
        (selectChange)="form.patchValue({ state: $event })"
      ></app-select>
    </label>

    <div class="edit-client-info-form__buttons edit-client-info-form__full">
      <button type="button" class="btn_text btn_sm" (click)="onClose()">Cancel</button>
      <button type="submit" [disabled]="form.invalid" class="btn_primary btn_sm">Save</button>
    </div>
  </form>
</app-base-modal>
